import generateIconUrl from "./generateIconUrl";
import {
    MEDICAL_CARDS_LIST_MAKE_PAGE_URI,
    SETTINGS_CONTENT_PAGE_URI,
    SETTINGS_FODLERS_PAGE_URI, SETTINGS_SECURITY_PAGE_URI, SETTINGS_WIDGET_PAGE_URI
} from "../constants/uri.constant";
import IncarnationEnum from "../enums/api/Incarnation";

export default function formatFolderToSideBarItems(folder, onClick, hasChildren){
    const defaultSideBardItem = {
        iconProps: {
            backendUrl: generateIconUrl(folder.icon || "folder", "icon")
        },
        addCard: !hasChildren,
        folderId: folder.id,
        link: MEDICAL_CARDS_LIST_MAKE_PAGE_URI(folder.id),
        title: folder.name,
        onClick: onClick,
        hash: folder.name.toLowerCase().replaceAll(" ", "-"),
        folder: folder
    }


    if(folder.incarnation.id === IncarnationEnum.id.folder){
        return {
            ...defaultSideBardItem,
            addCard: false,
            link: SETTINGS_FODLERS_PAGE_URI,
            hash: ""
        }
    }
    if(folder.incarnation.id === IncarnationEnum.id.catalog){
        return {
            ...defaultSideBardItem,
            addCard: false,
            link: SETTINGS_CONTENT_PAGE_URI,
            hash: ""
        }
    }
    if(folder.incarnation.id === IncarnationEnum.id.widgets){
        return {
            ...defaultSideBardItem,
            addCard: false,
            link: SETTINGS_WIDGET_PAGE_URI,
            hash: ""
        }
    }
    if(folder.incarnation.id === IncarnationEnum.id.permissions){
        return {
            ...defaultSideBardItem,
            addCard: false,
            link: SETTINGS_SECURITY_PAGE_URI,
            hash: ""
        }
    }

    return defaultSideBardItem
}
